import { useEffect, useRef } from "react";
import Carousel from "bootstrap/js/dist/carousel";

export default function Hero({ banners }) {
  const BaseUrl = process.env.REACT_APP_BASE_URL || "";
  const carouselRef = useRef(null);
  const slideCount = [
    banners?.slider_banner1,
    banners?.slider_banner2,
    banners?.slider_banner3,
  ].filter(Boolean).length;

  useEffect(() => {
    const carouselElement = carouselRef.current;
    if (!carouselElement || slideCount < 2) {
      return;
    }

    const carousel = Carousel.getOrCreateInstance(carouselElement, {
      interval: 3000,
      ride: "carousel",
    });

    return () => carousel.dispose();
  }, [slideCount]);

  if (!banners) {
    return (
      <div className="w-full bg-gray-100 animate-pulse min-h-[220px] sm:min-h-[360px] md:min-h-[480px] lg:min-h-[560px] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-gray-300 border-t-[#77C712] rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div
      ref={carouselRef}
      id="heroCarousel"
      className="carousel slide relative overflow-hidden min-h-[200px]"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        {banners?.slider_banner1 && (
          <div className="carousel-item active">
            <img
              src={`${BaseUrl}/${banners.slider_banner1}`}
              className="d-block w-100 hero-section-img-home"
              alt="Ayurvedic Wellness Banner 1"
              fetchpriority="high"
              decoding="async"
            />
          </div>
        )}

        {banners?.slider_banner2 && (
          <div className="carousel-item">
            <img
              src={`${BaseUrl}/${banners.slider_banner2}`}
              className="d-block w-100 hero-section-img-home"
              alt="Ayurvedic Wellness Banner 2"
              loading="lazy"
              decoding="async"
            />
          </div>
        )}

        {banners?.slider_banner3 && (
          <div className="carousel-item">
            <img
              src={`${BaseUrl}/${banners.slider_banner3}`}
              className="d-block w-100 hero-section-img-home"
              alt="Ayurvedic Wellness Banner 3"
              loading="lazy"
              decoding="async"
            />
          </div>
        )}
      </div>

      {/* Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="prev"
        aria-label="Previous Slide"
      >
        <span className="carousel-control-prev-icon" />
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="next"
        aria-label="Next Slide"
      >
        <span className="carousel-control-next-icon" />
      </button>
    </div>
  );
}
